import { useState, useEffect, useRef } from 'react';

export const useDropdownState = () => {
  // Dropdown state
  const [isShowDatesDropdownOpen, setIsShowDatesDropdownOpen] = useState(false);
  const [isHoursPerDayDropdownOpen, setIsHoursPerDayDropdownOpen] = useState(false);
  const [isWeekOffDaysDropdownOpen, setIsWeekOffDaysDropdownOpen] = useState(false);

  // Dropdown refs
  const showDatesDropdownRef = useRef<HTMLDivElement>(null);
  const hoursPerDayDropdownRef = useRef<HTMLDivElement>(null);
  const weekOffDaysDropdownRef = useRef<HTMLDivElement>(null);

  // Click outside handler for dropdowns
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (showDatesDropdownRef.current && !showDatesDropdownRef.current.contains(event.target as Node)) {
        setIsShowDatesDropdownOpen(false);
      }
      if (hoursPerDayDropdownRef.current && !hoursPerDayDropdownRef.current.contains(event.target as Node)) {
        setIsHoursPerDayDropdownOpen(false);
      }
      if (weekOffDaysDropdownRef.current && !weekOffDaysDropdownRef.current.contains(event.target as Node)) {
        setIsWeekOffDaysDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return {
    // Show dates dropdown
    isShowDatesDropdownOpen,
    setIsShowDatesDropdownOpen,
    showDatesDropdownRef,

    // Hours per day dropdown
    isHoursPerDayDropdownOpen,
    setIsHoursPerDayDropdownOpen,
    hoursPerDayDropdownRef,

    // Week-off days dropdown
    isWeekOffDaysDropdownOpen,
    setIsWeekOffDaysDropdownOpen,
    weekOffDaysDropdownRef,
  };
};
